import { Outlet } from "react-router";
import TopNav from "./TopNav";
import { Container } from "react-bootstrap";
import Footer from "./Footer";

export default function PublicLayout({
  withBackground = false,
  hasAuth = false,
  container = false,
}: {
  withBackground?: boolean;
  hasAuth?: boolean;
  container?: boolean;
}) {
  return (
    <div className={`public-layout${withBackground ? " with-background" : ""}`}>
      <TopNav hasAuth={hasAuth} />
      {container ? (
        <Container>
          <Outlet />
        </Container>
      ) : (
        <Outlet />
      )}
      <Footer />
    </div>
  );
}
